import { render, staticRenderFns } from "./TriggerClaimCompleteEmail.vue?vue&type=template&id=15044fc2&scoped=true&"
import script from "./TriggerClaimCompleteEmail.vue?vue&type=script&lang=js&"
export * from "./TriggerClaimCompleteEmail.vue?vue&type=script&lang=js&"
import style0 from "./TriggerClaimCompleteEmail.vue?vue&type=style&index=0&id=15044fc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15044fc2",
  null
  
)

export default component.exports